const STOPWORDS = {
  he: ["אני", "שלי", "של", "עם", "כי", "אבל", "רק", "זה", "היום", "שאני", "יותר", "פחות", "גם", "אם", "מה", "על", "בתוך", "כמו", "עוד", "הוא", "היא", "הם", "הן", "היה", "היתה", "הייתי", "יש", "אין"],
  en: ["i", "me", "my", "the", "and", "but", "that", "this", "with", "for", "to", "a", "an", "of", "in", "on", "it", "is", "was", "are", "am", "be", "been", "have", "has", "had"],
  es: ["yo", "me", "mi", "mis", "el", "la", "y", "pero", "que", "esto", "esta", "con", "para", "de", "en", "un", "una", "es", "fue", "son", "soy", "he", "ha", "han", "habia"],
};

function tokenize(text) {
  return String(text || "")
    .toLowerCase()
    .replace(/[^\p{L}\p{N}\s]/gu, " ")
    .split(/\s+/)
    .map((token) => token.trim())
    .filter(Boolean);
}

export function buildInsights({ lang, entries }) {
  const safeLang = lang || "he";
  const stop = new Set(STOPWORDS[safeLang] || []);
  const counts = new Map();
  const helped = [];

  entries.forEach((entry) => {
    const text = String(entry?.text || "");
    tokenize(text).forEach((word) => {
      if (word.length < 3) return;
      if (stop.has(word)) return;
      counts.set(word, (counts.get(word) || 0) + 1);
    });

    if (safeLang === "he") {
      if (text.includes("עזר לי") || text.includes("זה עזר")) {
        helped.push(text);
      }
    } else if (safeLang === "es") {
      if (text.toLowerCase().includes("me ayudo") || text.toLowerCase().includes("me ayudó")) {
        helped.push(text);
      }
    } else {
      if (text.toLowerCase().includes("helped me")) {
        helped.push(text);
      }
    }
  });

  const repeatingWords = Array.from(counts.entries())
    .sort((a, b) => b[1] - a[1])
    .slice(0, 3)
    .map(([word]) => word);

  let whatHelped = [];
  if (helped.length) {
    whatHelped = helped.slice(-2);
  } else {
    whatHelped = safeLang === "he"
      ? ["אני עדיין לומד מה עוזר לי."]
      : safeLang === "es"
        ? ["Todavia estoy aprendiendo lo que me ayuda."]
        : ["I am still learning what helps me."];
  }

  const nextStep = safeLang === "he"
    ? "אני בוחר צעד קטן אחד להיום."
    : safeLang === "es"
      ? "Elijo un paso pequeno para hoy."
      : "I choose one small step for today.";

  return {
    repeatingWords,
    whatHelped,
    nextStep,
  };
}
